import { divide } from 'lodash';
import { ReactComponent as LandIcon } from 'images/object-fence.svg';
import BaseRealEstateObject from './BaseRealEstateObject';

export default class Land extends BaseRealEstateObject {
  constructor(config) {
    super(config);

    this.icon = LandIcon;
    this.iconClass = 'icon_fence';
    this.sntsType =
      config.propertyType === 2 && divide(config.shareNumerator, config.shareDenominator) !== 1
        ? 'Доля в земле'
        : 'Земельный участок';
  }

  static typeTitle = 'Земельный участок';

  getTypeTitle() {
    return Land.typeTitle;
  }

  getCategoryTitle() {
    return this.title || Land.typeTitle;
  }

  getPdfTitle() {
    return `${Land.typeTitle}, ${this.address}`;
  }

  isLand() {
    return true;
  }
}
